import React, { useEffect, useState } from "react";
import ApiUtil from "../api/ApiUtil";
import DataTable from "react-data-table-component";
import CustomModal from "../components/common/Modal";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ProductsRedirections = () => {
  const [redirectedProducts, setRedirectedProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isSingleModalOpen, setIsSingleModalOpen] = useState(false);
  const [selectableRows, setSelectableRows] = useState(null);
  const [redirectedProductId, setRedirectedProductId] = useState("");

  useEffect(() => {
    getReirectedProductsHandler();
  }, []);

  const getReirectedProductsHandler = async () => {
    try {
      const response = await ApiUtil.SendAsync({
        url: "/redirection/all",
        method: "GET",
      });

      const redirectedProductsRecords = response.data.data;

      setRedirectedProducts(
        redirectedProductsRecords?.redirectionroducts || []
      );
    } catch (error) {
      console.error("Error exporting products:", error);
    }
  };

  const rowUpdateHandler = (row) => {
    setIsSingleModalOpen(true);
    setSelectableRows(row);
    setRedirectedProductId("");
  };

  const onCancelAndOkHandler = () => {
    setIsSingleModalOpen(false);
    setSelectableRows(null);
    setRedirectedProductId("");
  };

  const onUpdateHandler = async () => {
    setLoading(true);

    try {
      const response = await ApiUtil.SendAsync({
        url: `/redirection/add/${selectableRows._id}/${redirectedProductId}`,
        method: "PUT",
      });

      if (response.status === 200) {
        toast.success("Product redirection updated successfully!");
      }
    } catch (error) {
      console.error("Error updating product:", error);
      toast.error("Something went wrong. Please try again.");
    } finally {
      await getReirectedProductsHandler();
      await onCancelAndOkHandler();
    }

    setLoading(false);
  };

  const columns = [
    {
      name: "Product Name",
      selector: (row) =>
        row.deletedProductName ? row.deletedProductName : "N/A",
    },
    {
      name: "Product Slug",
      selector: (row) =>
        row.deletedProductSlug ? row.deletedProductSlug : "N/A",
    },
    {
      name: "Redirected Product Name",
      selector: (row) =>
        row.redirectedProductName ? row.redirectedProductName : "N/A",
    },
    {
      name: "Redirected Product Slug",
      selector: (row) =>
        row.redirectedProductSlug ? row.redirectedProductSlug : "N/A",
    },

    {
      name: "Update",
      selector: (row) => (
        <button
          className="btn btn-primary fw-bold shadow border-0"
          style={{ borderRadius: "10px", backgroundColor: "#e67929" }}
          onClick={() => rowUpdateHandler(row)}
        >
          Update
        </button>
      ),
    },
  ];

  const customStyles = {
    rows: {
      style: {
        minHeight: "50px",
        backgroundColor: "white",
        marginTop: "7px",
        boxShadow: " 0px 2px 2px #ced4da",
        transition: "background-color 0.3s",
        "&:hover": {
          backgroundColor: "#f0f0f0",
          cursor: "pointer",
        },
      },
    },

    headCells: {
      style: {
        backgroundColor: "rgb(230, 121, 41)",
        fontSize: "15px",
        color: "white",
        fontWeight: "600",
        boxShadow: "0 2px 2px 0 #ced4da, 0 2px 4px 0 rgba(0, 0, 0, 0.19)",
      },
    },

    scrollbar: {
      width: "18px",
      track: {
        backgroundColor: "#f5f5f5",
        borderRadius: "8px", // Customize as needed
      },
      thumb: {
        backgroundColor: "#888",
        borderRadius: "8px", // Customize as needed
      },
    },
  };

  return (
    <>
      <DataTable
        columns={columns}
        data={redirectedProducts}
        customStyles={customStyles}
      />
      <CustomModal
        onOk={() => onCancelAndOkHandler()}
        onCancel={() => onCancelAndOkHandler()}
        open={isSingleModalOpen}
        title={"Add Redirection Product Slug"}
      >
        <p>
          <strong>Deleted Product Name : </strong>
          {selectableRows?.deletedProductName}
        </p>
        <p>
          <strong>Deleted Product Slug : </strong>
          {selectableRows?.deletedProductSlug}
        </p>
        <p>
          <strong>Redirected Product Name : </strong>
          {selectableRows?.redirectedProductName || "N/A"}
        </p>
        <p>
          <strong>Redirected Product Slug : </strong>
          {selectableRows?.redirectedProductSlug || "N/A"}
        </p>
        <div className="form-group mt-5">
          <label htmlFor="redirectedProductId">
            <strong>Redirected Product ID:</strong>
          </label>
          <input
            type="text"
            id="redirectedProductId"
            className="form-control"
            placeholder="Enter Redirected Product ID"
            value={redirectedProductId}
            onChange={(e) => setRedirectedProductId(e.target.value)}
          />
          <button
            className="btn btn-primary fw-bold shadow border-0 mt-1"
            style={{ borderRadius: "10px", backgroundColor: "#e67929" }}
            onClick={() => onUpdateHandler()}
          >
            {loading ? "Updating..." : "Update"}
          </button>
        </div>
      </CustomModal>
    </>
  );
};

export default ProductsRedirections;
